// <sticky-atc> (§7.5): por debajo de 750 px, cuando el botón principal sale de la vista, aparece una barra fija
// con precio, «Añadir al carrito» (o «Elegir talla») y «Ayúdame con la talla». Se oculta con el teclado abierto
// y con el carrito abierto, respeta safe-area y reserva espacio para no tapar el foco (2.4.11).
class StickyAtc extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('[data-section="main-product"]');
    this.product = JSON.parse(this.section.querySelector('[data-product-json]').textContent);
    this.button = this.querySelector('[data-sticky-add]');
    this.target = this.section.querySelector('.product__form form button');
    this.mobile = matchMedia('(max-width: 749px)');
    this.offscreen = false;
    this.blocked = false;
    this.variant = null;

    // Scroll pasivo limitado a un fotograma: funciona también si se salta de golpe (un enlace con ancla),
    // cosa que un IntersectionObserver no detecta cuando el botón pasa de «debajo» a «encima» sin verse.
    let ticking = false;
    const update = () => {
      ticking = false;
      this.offscreen = this.target.getBoundingClientRect().bottom < 0;
      this.render();
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
    window.visualViewport?.addEventListener('resize', () => this.render());
    this.mobile.addEventListener('change', () => this.render());
    document.addEventListener('cart:drawer', (event) => {
      this.blocked = event.detail.open;
      this.render();
    });
    this.chooseLabel = this.button.textContent;
    const onVariant = (variant) => {
      this.variant = variant;
      this.button.textContent = this.variant?.available ? this.product.strings.addToCart : this.chooseLabel;
    };
    document.addEventListener('variant:change', (event) => {
      if (event.detail.productHandle === this.product.handle) onVariant(event.detail.variant);
    });
    if (this.section.variantState) onVariant(this.section.variantState.variant);
    this.button.addEventListener('click', () => {
      if (this.variant?.available) this.section.querySelector('.product__form form').requestSubmit();
      else {
        const picker = this.section.querySelector('variant-picker');
        picker.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        (picker.querySelector('.product-option input:not(:disabled)'))?.focus({ preventScroll: true });
      }
    });
  }

  keyboardOpen() {
    const vv = window.visualViewport;
    return vv ? vv.height < window.innerHeight * 0.75 : false;
  }

  render() {
    const show = this.mobile.matches && this.offscreen && !this.blocked && !this.keyboardOpen();
    const appearing = show && this.hidden;
    this.hidden = !show;
    document.body.classList.toggle('has-sticky-atc', show);
    // scroll-padding en el elemento que hace scroll: al tabular, el foco nunca queda debajo de la barra (técnica C43).
    document.documentElement.classList.toggle('has-sticky-atc', show);
    if (appearing) this.revealFocus();
  }

  /** Si la barra aparece encima del elemento con foco, lo sube por encima de ella (2.4.11). */
  revealFocus() {
    const active = document.activeElement;
    if (!active || active === document.body || this.contains(active)) return;
    if (active.getBoundingClientRect().bottom > this.getBoundingClientRect().top) active.scrollIntoView({ block: 'nearest' });
  }
}

customElements.define('sticky-atc', StickyAtc);
